import { Menu as ChakraMenu, Portal } from "@chakra-ui/react"
import { forwardRef } from "react"
import { getThemeColor } from "theme/colors"

export const MenuRoot = ChakraMenu.Root

export const MenuTrigger = ChakraMenu.Trigger

export const MenuContent = forwardRef((props: any, ref) => {
  return (
    <Portal>
      <ChakraMenu.Positioner>
        <ChakraMenu.Content
          ref={ref}
          bg={getThemeColor('modal.bg')}
          borderColor={getThemeColor('border.default')}
          borderWidth="1px"
          borderRadius="md"
          boxShadow="lg"
          py={1}
          minW="200px"
          {...props}
        />
      </ChakraMenu.Positioner>
    </Portal>
  )
})

MenuContent.displayName = "MenuContent"

export const MenuItem = forwardRef((props: any, ref) => {
  const { children, ...rest } = props
  return (
    <ChakraMenu.Item
      ref={ref}
      color={getThemeColor('text.primary')}
      _hover={{
        bg: getThemeColor('bg.hover'),
      }}
      px={3}
      py={2}
      cursor="pointer"
      display="flex"
      alignItems="center"
      gap={2}
      fontSize="sm"
      {...rest}
    >
      {children}
    </ChakraMenu.Item>
  )
})

MenuItem.displayName = "MenuItem"

export const MenuSeparator = forwardRef((props: any, ref) => {
  return (
    <ChakraMenu.Separator
      ref={ref}
      borderColor={getThemeColor('border.default')}
      my={1}
      {...props}
    />
  )
})

MenuSeparator.displayName = "MenuSeparator"
